import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, withWidth, TextField, LinearProgress, Snackbar, SnackbarContent } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import LoginBackground from "./LoginBackground.jpg";
import EULADialogue from "./EULADialogue";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { login, navigateToDashboard, agreeToEula, getAppUrl, forgotPwd } from "./actions";
import EmailIcon from "@material-ui/icons/Email";
import LockIcon from "@material-ui/icons/Lock";
import { selectLoginRequesting, selectLoginFail, selectUserAgreedToEULA, selectUser, selectAppUrl } from "./selectors";

var styles = function styles(theme) {
  return {
    loginContainer: {
      padding: 0,
      margin: 0,
      minWidth: "100%",
      minHeight: "100vh",
      backgroundImage: "url('".concat(LoginBackground, "')"),
      backgroundSize: "Cover",
      backgroundColor: "rgba(0, 0, 0, 0)"
    },
    loginDialog: {
      color: "black",
      minHeight: "449px",
      maxWidth: "588px"
    },
    dialogBack: {
      color: "white",
      paddingLeft: "500px",
      backgroundColor: "rgba(0, 0, 0, 0)"
    }
  };
};

var Login = /*#__PURE__*/function (_Component) {
  _inherits(Login, _Component);

  var _super = _createSuper(Login);

  function Login(props) {
    var _this;

    _classCallCheck(this, Login);

    _this = _super.call(this, props);
    _this.state = {
      email: "",
      password: "",
      showLoginDialogue: true,
      showFullScreenDialogue: false,
      fgtpwdModal: false,
      fgtEmail: "",
      emailSentSuccess: false,
      emailSentFail: false
    };
    return _this;
  }

  _createClass(Login, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.agreedToEULA !== this.props.agreedToEULA && this.props.user !== false) {
        if (this.props.agreedToEULA === "Yes") {
          this.props.navigateToDashboard();
        } else {
          this.setState(_objectSpread({}, this.state, {
            showFullScreenDialogue: true
          }));
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          width = _this$props.width;
      console.log(width);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EULADialogue, {
        open: this.state.showFullScreenDialogue,
        handleClose: function handleClose() {
          _this2.setState(_objectSpread({}, _this2.state, {
            showFullScreenDialogue: false
          }));
        },
        handleAgree: function handleAgree() {
          _this2.props.agreeToEula();
        },
        appUrl: this.props.appUrl
      }), /*#__PURE__*/React.createElement("div", {
        className: classes.loginContainer,
        style: {
          backgroundColor: ""
        }
      }, /*#__PURE__*/React.createElement(Dialog, {
        open: this.state.showLoginDialogue,
        BackdropProps: {
          classes: {
            root: classes.dialogBack
          }
        },
        PaperProps: {
          classes: {
            root: classes.loginDialog
          }
        },
        style: {
          alignItems: "0",
          paddingLeft: width === "xs" || width === "sm" || width === "md" ? "0px" : "800px",
          backgroundColor: ""
        }
      }, /*#__PURE__*/React.createElement(DialogTitle, {
        style: {
          textAlign: "center"
        }
      }, /*#__PURE__*/React.createElement("b", {
        style: {
          color: "#0188CC"
        }
      }, "SIGN IN")), /*#__PURE__*/React.createElement(DialogContentText, {
        style: {
          textAlign: "center"
        }
      }, "Please enter your email address and password"), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(TextField, {
        style: {
          marginBottom: "14px",
          marginTop: "45px"
        },
        autoFocus: true,
        margin: "dense",
        id: "email",
        label: "Email Address",
        InputProps: {
          startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
            position: "start"
          }, /*#__PURE__*/React.createElement(EmailIcon, null))
        },
        type: "email",
        value: this.state.email,
        onChange: function onChange(e) {
          _this2.setState({
            email: e.target.value
          });
        },
        onKeyPress: function onKeyPress(e) {
          if (e.key === "Enter") {
            _this2.props.login(_this2.state.email, _this2.state.password);
          }
        },
        fullWidth: true,
        autoComplete: "username email",
        error: this.props.fail
      }), /*#__PURE__*/React.createElement(TextField, {
        style: {
          marginTop: "29px"
        },
        autoFocus: true,
        margin: "dense",
        id: "password",
        label: "Password",
        type: "password",
        InputProps: {
          startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
            position: "start"
          }, /*#__PURE__*/React.createElement(LockIcon, null))
        },
        value: this.state.password,
        onChange: function onChange(e) {
          _this2.setState({
            password: e.target.value
          });
        },
        fullWidth: true,
        onKeyPress: function onKeyPress(e) {
          if (e.key === "Enter") {
            _this2.props.login(_this2.state.email, _this2.state.password);
          }
        },
        autoComplete: "current-password",
        error: this.props.fail
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          transition: "opacity .1s ease-in",
          opacity: this.props.requesting ? 1 : 0
        }
      }, /*#__PURE__*/React.createElement(LinearProgress, null))), /*#__PURE__*/React.createElement(DialogActions, {
        style: {
          display: "contents"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          _this2.props.login(_this2.state.email, _this2.state.password);
        },
        variant: "contained",
        size: "large",
        style: {
          backgroundColor: "#0188CC",
          color: "white",
          borderRadius: "52px"
        }
      }, "SIGN IN"), /*#__PURE__*/React.createElement(Button, {
        disabled: !this.state.email,
        onClick: function onClick() {
          _this2.props.forgotPwd(_this2.state.email);

          _this2.setState({
            emailSentSuccess: true
          });

          setTimeout(function () {
            window.location.reload();
          }, 2e3);
        },
        size: "small",
        variant: "text"
      }, "Forgot Password?\xA0\xA0", /*#__PURE__*/React.createElement("p", {
        style: {
          color: "#0188CC",
          marginTop: "13px"
        }
      }, "Click here", " ")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Snackbar, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        autoHideDuration: 6000,
        open: this.state.emailSentSuccess,
        onClose: function onClose() {
          _this2.setState({
            emailSentSuccess: false
          });
        }
      }, /*#__PURE__*/React.createElement(SnackbarContent, {
        style: {
          backgroundColor: "green",
          color: "white"
        },
        message: "Email has been Sent!"
      })), /*#__PURE__*/React.createElement(Snackbar, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        autoHideDuration: 6000,
        open: this.state.emailSentFail,
        onClose: function onClose() {
          _this2.setState({
            emailSentFail: false
          });
        }
      }, /*#__PURE__*/React.createElement(SnackbarContent, {
        style: {
          backgroundColor: "green",
          color: "white"
        },
        message: "Please Enter Email Address "
      }))))));
    }
  }]);

  return Login;
}(Component);

export default connect(function (store) {
  return {
    requesting: selectLoginRequesting(store),
    fail: selectLoginFail(store),
    agreedToEULA: selectUserAgreedToEULA(store),
    user: selectUser(store),
    appUrl: selectAppUrl(store)
  };
}, {
  login: login,
  navigateToDashboard: navigateToDashboard,
  agreeToEula: agreeToEula,
  getAppUrl: getAppUrl,
  forgotPwd: forgotPwd
})(withStyles(styles)(withWidth()(Login)));